"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClassUtil_1 = require("../util/ClassUtil");
var PublicKey_1 = require("../keys/PublicKey");
var DecryptError_1 = require("../errors/DecryptError");
var ProteusError_1 = require("../errors/ProteusError");
var ChainKey_1 = require("./ChainKey");
var MessageKeys_1 = require("./MessageKeys");
var RecvChain = (function () {
    function RecvChain() {
        this.chain_key = new ChainKey_1.default();
        this.message_keys = [];
        this.ratchet_key = new PublicKey_1.default();
    }
    RecvChain.new = function (chain_key, public_key) {
        var rc = ClassUtil_1.default.new_instance(RecvChain);
        rc.chain_key = chain_key;
        rc.ratchet_key = public_key;
        rc.message_keys = [];
        return rc;
    };
    RecvChain.prototype.try_message_keys = function (envelope, msg) {
        if (this.message_keys[0] && this.message_keys[0].counter > msg.counter) {
            var message = "Message too old. Counter for oldest staged chain key is '" + this.message_keys[0].counter + "' while message counter is '" + msg.counter + "'.";
            throw new DecryptError_1.default.OutdatedMessage(message, DecryptError_1.default.CODE.CASE_208);
        }
        var idx = this.message_keys.findIndex(function (mk) {
            return mk.counter === msg.counter;
        });
        if (idx === -1) {
            throw new DecryptError_1.default.DuplicateMessage(undefined, DecryptError_1.default.CODE.CASE_209);
        }
        var mk = this.message_keys.splice(idx, 1)[0];
        if (!envelope.verify(mk.mac_key)) {
            var message = "Envelope verification failed for message with counter behind. Message index is '" + msg.counter + "' while receive chain index is '" + this.chain_key.idx + "'.";
            throw new DecryptError_1.default.InvalidSignature(message, DecryptError_1.default.CODE.CASE_210);
        }
        return mk.decrypt(msg.cipher_text);
    };
    RecvChain.prototype.stage_message_keys = function (msg) {
        var num = msg.counter - this.chain_key.idx;
        if (num > RecvChain.MAX_COUNTER_GAP) {
            if (this.chain_key.idx === 0) {
                throw new DecryptError_1.default.TooDistantFuture('Skipped too many message at the beginning of a receive chain.', DecryptError_1.default.CODE.CASE_211);
            }
            throw new DecryptError_1.default.TooDistantFuture("Skipped too many message within a used receive chain. Receive chain counter is '" + this.chain_key.idx + "'", DecryptError_1.default.CODE.CASE_212);
        }
        var keys = [];
        var chk = this.chain_key;
        for (var index = 0; index <= num - 1; index++) {
            keys.push(chk.message_keys());
            chk = chk.next();
        }
        var mk = chk.message_keys();
        return [chk, mk, keys];
    };
    RecvChain.prototype.commit_message_keys = function (keys) {
        var _this = this;
        if (keys.length > RecvChain.MAX_COUNTER_GAP) {
            throw new ProteusError_1.default("Number of message keys (" + keys.length + ") exceed message chain counter gap (" + RecvChain.MAX_COUNTER_GAP + ").", ProteusError_1.default.CODE.CASE_103);
        }
        var excess = this.message_keys.length + keys.length - RecvChain.MAX_COUNTER_GAP;
        for (var index = 0; index <= excess - 1; index++) {
            this.message_keys.shift();
        }
        keys.map(function (key) { return _this.message_keys.push(key); });
        if (keys.length > RecvChain.MAX_COUNTER_GAP) {
            throw new ProteusError_1.default("Skipped message keys which exceed the message chain counter gap (" + RecvChain.MAX_COUNTER_GAP + ").", ProteusError_1.default.CODE.CASE_104);
        }
    };
    RecvChain.prototype.encode = function (encoder) {
        encoder.object(3);
        encoder.u8(0);
        this.chain_key.encode(encoder);
        encoder.u8(1);
        this.ratchet_key.encode(encoder);
        encoder.u8(2);
        encoder.array(this.message_keys.length);
        return this.message_keys.map(function (key) { return key.encode(encoder); });
    };
    RecvChain.decode = function (decoder) {
        var self = ClassUtil_1.default.new_instance(RecvChain);
        var nprops = decoder.object();
        for (var index = 0; index <= nprops - 1; index++) {
            switch (decoder.u8()) {
                case 0: {
                    self.chain_key = ChainKey_1.default.decode(decoder);
                    break;
                }
                case 1: {
                    self.ratchet_key = PublicKey_1.default.decode(decoder);
                    break;
                }
                case 2: {
                    self.message_keys = [];
                    var len = decoder.array();
                    while (len--) {
                        self.message_keys.push(MessageKeys_1.default.decode(decoder));
                    }
                    break;
                }
                default: {
                    decoder.skip();
                }
            }
        }
        return self;
    };
    RecvChain.MAX_COUNTER_GAP = 1000;
    return RecvChain;
}());
exports.default = RecvChain;
//# sourceMappingURL=RecvChain.js.map


//////////////////
// WEBPACK FOOTER
// ../proteus/dist/session/RecvChain.js
// module id = 102
// module chunks = 0 1